var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.061,
    height: 15.353,
    viewBox: "0 0 16.061 15.353",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.646 15.353V4.994H.2v10.359ZM1.925 3.579A1.8 1.8 0 1 0 1.948 0 1.794 1.794 0 1 0 1.9 3.579h.022Zm3.626 11.774h3.443V9.568a2.357 2.357 0 0 1 .113-.84 1.885 1.885 0 0 1 1.766-1.259c1.246 0 1.744.95 1.744 2.342v5.542h3.443v-5.94c0-3.182-1.7-4.662-3.964-4.662A3.429 3.429 0 0 0 8.971 6.5h.023V5H5.552c.045.972 0 10.358 0 10.358Z",
    fill: "#221f1f"
  })));
};
export default SvgLinkedin;